//import { createApp } from 'vue'
//import App from './App.vue'

//createApp(App).mount('#app')

/*
import Vue from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
//import 'ant-design-vue/dist/antd.css';

Vue.config.productionTip = false;

Vue.use(Antd);

new Vue({
  render: h => h(App),
}).$mount('#app');
*/
import { createApp } from 'vue';
import App from './App.vue';
import { 
  Button, 
  Card, 
  Input, 
  Select, 
  DatePicker, 
  Modal, 
  Checkbox, 
  List, 
  Avatar, 
  message,
  Popconfirm,
  Drawer,
  Tabs,
  Dropdown,
  Menu,
  Alert,
  ConfigProvider,
  Radio,
  Switch,
  Empty,
  Spin,
  Tag,
  Form
} from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import i18n from './i18n'; // Импортируем i18n
import './assets/styles/variables.css';
import './assets/styles/utilities.css';
import './assets/styles/dropdown.css';

// Импортируем русскую локализацию для Ant Design Vue
import ruRU from 'ant-design-vue/es/locale/ru_RU';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

// Настраиваем dayjs для русской локализации
dayjs.locale('ru');

import ThemeSwitcher from './components/ThemeSwitcher.vue'; // Импорт ThemeSwitcher
import ParticipationIcon from './components/ParticipationIcon.vue';
import { injectDropdownStyles } from './utils/dropdownStyles';
import { applyManifestFromStorageOnly } from './utils/earlyPwaManifest';

const app = createApp(App);

app.use(i18n); // Подключаем i18n

app.component('ThemeSwitcher', ThemeSwitcher); // Глобальная регистрация

app.component('ParticipationIcon', ParticipationIcon); // Глобальная регистрация

// Configure message globally
app.config.globalProperties.$message = message;

// Регистрация компонентов Ant Design Vue
app.use(Button);
app.use(Card);
app.use(Input);
app.use(Select);
app.use(DatePicker);
app.use(Modal);
app.use(Checkbox);
app.use(List);
app.use(Avatar);
app.use(Popconfirm);
app.use(Drawer);
app.use(Tabs);
app.use(Dropdown);
app.use(Menu);
app.use(Alert);
app.use(ConfigProvider);
app.use(Radio);
app.use(Switch);
app.use(Empty);
app.use(Spin);
app.use(Tag);
app.use(Form);

// Инжектируем стили для dropdown меню
injectDropdownStyles();

// Повторная подстановка manifest после парсинга head (на случай порядка загрузки)
applyManifestFromStorageOnly();

// Register Service Worker for PWA capabilities
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      console.log('Service Worker registered: ', registration);
    }).catch(registrationError => {
      console.log('Service Worker registration failed: ', registrationError);
    });
  });
}

// Монтируем приложение с русской локализацией
app.mount('#app');